export enum PromotionTypes {
  OrderDiscount = 'next-order-discount',
  SpendGet = 'spend_get',
}

export type AvailablePromotionsResponse = {
  promotions?: Promotion[]
}

export type AvailablePromotionsPayload = {
  availablePromotions: Promotion[]
  dollarTotalQualifyingCredit: number
}

type PromotionThreshold = {
  progress?: number
  remaining_amount?: number
  threshold_amount?: number
  effect_type?: string
  effect?: number
}

export type Promotion = {
  id?: number | null // campaigns id for tracking
  audience?: 'global' | 'targeted'
  promotion_id?: string | null //uuid of promotion
  type?: PromotionTypes | null
  display_name?: string | null
  display_description?: string | null
  disclaimer_body?: string | null
  disclaimer_header?: string | null
  full_terms_title?: string | null
  full_terms_url?: string | null
  terms?: string | null
  valid_through?: string | null
  valid_through_string?: string | null
  thresholds?: PromotionThreshold[] | null
  promotion_params?: PromotionParams | null
  member_only?: boolean
  available_store_ids?: number[] | null
  offer_headline?: string | null
  button_cta?: string | null
  progress_header?: string | null
  progress_subheader?: string | null
  progress?: number | null
  background_color?: string | null
  text_color?: string | null
  skip_store_selection?: boolean | null
}

type PromotionParams = {
  category_id?: number | null
  images?: { image_url: string }[] | null
  is_marketing_category?: boolean
  feature_promotion_group_id?: number | null
  original_price?: number | null
  hide_original_price?: boolean | null
  search_url?: string | null
  relative_link?: string | null
}
